import PropTypes from 'prop-types'
import {Button, Flex, Text, Divider} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const ConfirmationScreen = ({goToSetupExpenseAccount}) => {
  const {t} = useTranslation('connectPayoutAccount')

  return (
    <Flex justify="center">
      <Flex flexDirection="column" width="400px" pt={10}>
        <Flex flexDirection="inherit" gap={3}>
          <Text
            color="black"
            fontWeight="regular"
            fontSize="2xl"
            lineHeight="90%"
          >
            {t('modal.confirmation.title')}
          </Text>
          <Flex flexDirection="column" gap={2} pt={3}>
            <Text
              color="black"
              fontWeight="medium"
              fontSize="sm"
              lineHeight="125%"
              pb={2}
            >
              {t('modal.confirmation.description')}
            </Text>
          </Flex>
        </Flex>

        <Divider border="1px" borderColor="mld.neutral.600" my={5} />
        <Flex flexDirection="column" backgroundColor="mld.neutral.50" p={4}>
          <Flex flexDirection="column" gap={2}>
            <Text fontSize="xs" textTransform="uppercase">
              {t('modal.confirmation.nextStep.title')}
            </Text>
            <Text fontSize="sm" fontWeight="medium">
              {t('modal.confirmation.nextStep.subtitle')}
            </Text>
            <Text fontSize="xs" lineHeight="125%">
              {t('modal.confirmation.nextStep.description')}
            </Text>
          </Flex>
          <Button
            onClick={goToSetupExpenseAccount}
            variant="secondary"
            width="220px"
            mt={6}
            _hover={{}}
          >
            {t('modal.buttons.setUpExpenseAccount')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

ConfirmationScreen.propTypes = {
  goToSetupExpenseAccount: PropTypes.func.isRequired,
}

export default ConfirmationScreen
